import React from "react";

// Browser-style chrome frame around a real product screenshot.
export const ScreenshotFrame = ({ src, alt, label, className = "", testid }) => (
  <figure
    data-testid={testid}
    className={`rounded-xl overflow-hidden border border-border bg-card shadow-2xl shadow-black/40 ${className}`}
  >
    <div className="flex items-center gap-2 px-4 h-9 bg-secondary/70 border-b border-border">
      <span className="w-3 h-3 rounded-full bg-destructive/70" />
      <span className="w-3 h-3 rounded-full bg-accent/70" />
      <span className="w-3 h-3 rounded-full bg-emerald-500/70" />
      {label && (
        <span className="ml-3 text-[11px] font-mono-code text-muted-foreground truncate">{label}</span>
      )}
    </div>
    <img src={src} alt={alt} loading="lazy" className="w-full block" />
  </figure>
);
